import { Box, Container, Paper, useTheme } from "@mui/material";
import { HBRLoginItem } from "../../components/modals/loginModal";
import { useNavigate } from "react-router-dom";

export const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Box
      sx={{
        height: "100vh",
        background: `linear-gradient(135deg, ${theme.palette.primary.light}, ${theme.palette.secondary.light})`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >

      <Container component="main" maxWidth="xs">
        <Paper elevation={6} sx={{ padding: 4, borderRadius: 2 }}>
          <HBRLoginItem onLogin={() => navigate("/app/")} />
        </Paper>
      </Container>
    </Box>
  );
};
